import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { CacheService, StaffItem } from '../../../../../services/cache.service';
import { AppToastService } from '../../../widgets/services/app-toast.service';
import { MiroHomeModel, TileService } from '../../../widgets/services/tile.service';
import { ITileOrder, TileContainerComponent } from '../../../widgets/tile-container/tile-container.component';
import { Tile } from '../../../widgets/tile/tile.component';
import { MiroBoard, MiroService } from '../../services/miro.service';
import { CommonModule } from '@angular/common';
import { Staff } from '../../../common/model/Staff';

@Component({
  selector: 'app-miro',
  standalone: true,
  imports: [FormsModule, CommonModule, TileContainerComponent],
  templateUrl: './page-miro.component.html',
  styleUrls: ['./page-miro.component.scss']
})
export class PageMiroComponent implements OnInit, OnDestroy {
  miroboards: MiroBoard[] = [];
  tileColor: string = "secondary";
  tileTitle: string = "Whiteboards";
  tiles: Tile[] = [];
  params: any[] = [];
  currentUser!: StaffItem;
  miroSubscription: Subscription;
  miroTokenExistance: boolean = false;
  miroModel: MiroHomeModel = {};
  popupWindow: Window | null = null;

  constructor(private service: MiroService, private cache: CacheService, private toaster: AppToastService, private modalService: NgbModal, private router: Router, private tileService: TileService) {

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.miroSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
      }
    });

    service.changeEmitted$.subscribe(data => {
      this.router.navigate([this.router.url])
    })
  }

  async ngOnInit() {
    this.tileService.getCurrentUser().then((data: any) => {
      this.currentUser = data.emailAddress;
      this.retrieveMiroBoards(this.currentUser);
    });
    await this.isMiroTokenExist();

  }

  ngOnDestroy() {
    if (this.miroSubscription) {
      this.miroSubscription.unsubscribe();
    }
  }

  retrieveMiroBoards(useremail: any): void {
    this.service.getMiroBoardsForUser(useremail)
      .subscribe(
        data => {
          this.miroboards = data;
          this.loadItems();
          this.tiles = this.getTiles();
        },
        error => {
          if (error.status == 500) {
            this.authenticateMiro();
          }
        });
  }

  private loadItems(): void {
    this.miroboards.forEach((board) => {
      board.tile = {
        color: this.tileColor,
        type: "unset",
        title: this.tileTitle,
        size: "xlarge",
        id: board.id!,
        cssclass: "tilebutton",
        ispinned: false
      };
    });
  }

  getTiles(): Tile[] {
    return this.miroboards.map((board) => {
      var tile = board.tile;
      tile.data = board;
      return tile;
    });
  }

  activateLink(board: MiroBoard) {
    if (board.id) {
      this.service.showMiroBoard(board.id);
    }
  }

  public addTileToast(event: Tile) {
    this.toaster.show('Tile Pinned', 'Tile ' + event.title + ', with title: ' + event.data.name + ' was changed to ' + (event.ispinned ? 'pinned' : 'unpinned'), 5000);
  }

  orderChange(event: ITileOrder[]) {

  }

  public addNewTile() {
    if (!this.miroTokenExistance) {
      this.authenticateMiroAndOpenCreatePopup();
    }
    else {
      this.service.addMiroBoard([]);
    }
  }
  async isMiroTokenExist() {
    await this.tileService.isMiroExist().then((data) => {
      this.miroTokenExistance = data;
      if (!this.miroTokenExistance) {
        this.authenticateMiro();
      }
    })
  }
  async authenticateMiro() {
    await this.tileService.getMiroDetails().then((data) => {
      this.miroModel = data;
      var url = this.miroModel.authoriseUrl;
      var client_id = this.miroModel.clientId;
      var team_id = this.miroModel.teamId;
      var redirect_uri = this.miroModel.callBackTokenUrl;
      var qs = "?response_type=code&client_id=" + client_id + "&redirect_uri=" + redirect_uri + "&state=abc123&team_id=" + team_id;
      var w = 900;
      var h = 600;
      const y = (window.top as Window).outerHeight / 2 + (window.top as Window).screenY - (h / 2);
      const x = (window.top as Window).outerWidth / 2 + (window.top as Window).screenX - (w / 2);
      this.popupWindow = window.open(url + qs, "popupWindow", `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${y}, left=${x}`);
      const interval = setInterval(() => {
        if (this.popupWindow && this.popupWindow.closed) {
          clearInterval(interval);
          this.tileService.isMiroExist().then((data) => {
            this.miroTokenExistance = data;
            if (this.miroTokenExistance) {
              window.location.reload();
            }
          });
        }
      }, 200)
    });
  }

  async authenticateMiroAndOpenCreatePopup() {
    await this.tileService.getMiroDetails().then((data) => {
      this.miroModel = data;
      var url = this.miroModel.authoriseUrl;
      var client_id = this.miroModel.clientId;
      var team_id = this.miroModel.teamId;
      var redirect_uri = this.miroModel.callBackTokenUrl;
      var qs = "?response_type=code&client_id=" + client_id + "&redirect_uri=" + redirect_uri + "&state=abc123&team_id=" + team_id;
      var w = 900;
      var h = 600;    
      const y = (window.top as Window).outerHeight / 2 + (window.top as Window).screenY - (h / 2);
      const x = (window.top as Window).outerWidth / 2 + (window.top as Window).screenX - (w / 2);
      this.popupWindow = window.open(url + qs, "popupWindow", `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${y}, left=${x}`);
      const interval = setInterval(() => {
        if (this.popupWindow && this.popupWindow.closed) {
          clearInterval(interval);
          this.tileService.isMiroExist().then((data) => {
            this.miroTokenExistance = data;
            if (this.miroTokenExistance) {
              this.service.addMiroBoard([]);
            }
          });
        }
      }, 200)
    });
  }
}
